import React, { FC } from "react";

import style from "./style.scss";

const SidebarView: FC = () => {
    return (
        <div className={style.container}>
            <div id="sidebar_view_container">
                {/*
                    This container exists as a root for rendering secondary
                    menus via the SidebarView component
                */}
            </div>
        </div>
    );
};

export { SidebarView };
